import { PropsWithChildren } from 'react';

export const FooterMenu = ({ children }: PropsWithChildren<{}>) => {
  return (
    <div className="grid grid-cols-12 grid-rows-2 gap-8 border-b border-grey-600 pb-20 text-white lg:gap-4">
      {children}
    </div>
  );
};
